import { createContext, useContext, useState } from "react";

const SurveyModeContext = createContext();

export default function SurveyModeProvider({ children }) {
  const [debug_mode, setDebugMode] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);
  
  const handleShowSurvey = () => setShowSurvey(true);
  const handleCloseSurvey = () => setShowSurvey(false);

  const changeDebug = (isDebug) => {
    setDebugMode(isDebug);
  };

  return (
    <SurveyModeContext.Provider
      value={{
        debug_mode,
        changeDebug,
        showSurvey,
        handleShowSurvey,
        handleCloseSurvey,
      }}
    >
      {children}
    </SurveyModeContext.Provider>
  );
}

export function useSurveyMode() {
  return useContext(SurveyModeContext);
}
